import { render, staticRenderFns } from "./SnapchatPlatformIcon.vue?vue&type=template&id=63bd43a8&scoped=true"
import script from "./SnapchatPlatformIcon.vue?vue&type=script&lang=js"
export * from "./SnapchatPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd43a8",
  null
  
)

export default component.exports